import { useState, useEffect } from 'react';
import { config } from '../../../config';
import { prepareHeaders } from '../../../configuration/tokenHandling/prepareHeaders';
import { type TableViewTogglesViewType } from '@rio-cloud/rio-uikit/TableViewToggles';
import { useSelectVehicleStore } from '../../../services/selectVehicleSlice';
import { IPagination } from '../../../shared/models/IPagination';
import { IConnectionEngagement } from '../models/IConnectionEngagement';
import { intToMonth } from '../../../shared/utils/formatters';

type UseConnectionEngamentDataProps = {
  externalViewType: TableViewTogglesViewType;
  assetId: string | undefined;
  offset: number;
};

interface IApiResponse {
  items: IConnectionEngagementItem[],
  pagination: IPagination
}

interface IConnectionEngagementItem {
  month: number,
  year: number,
  monthScore: number,
  averageScore: number,
  activeServices: number,
  relationshipTime: number,
  [key: string]: any;
}

export const useConnectionEngagementData = ({
assetId, offset}: UseConnectionEngamentDataProps) => {
  const [ connectionEngagementResponseList, setConnectionEngagementResponseList ] = useState<IConnectionEngagement[]>([]);
  const [ isLoading, setIsLoading ] = useState(false);
  const [ error, setError ] = useState(null);
  const [pagination, setPagination] = useState<IPagination>();
  const { clearSelectedVehicle } = useSelectVehicleStore();

  useEffect(() => {

    const getConnectionEngagementData = async () => {
      setIsLoading(true);
      setError(null);
      clearSelectedVehicle();
      try {
        const headers = await prepareHeaders(new Headers());
        const response = await fetch(config.backend.SCORES_SERVICE + `/v2/relationships/${assetId}/connection-engagement?offset=${offset}&size=50`, {
          method: 'GET',
          headers
        });
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const data = (await response.json()) as IApiResponse;

        setPagination(data.pagination);

        setConnectionEngagementResponseList(data.items.map((item: IConnectionEngagementItem) => {
          const result: IConnectionEngagement = {
            date: `${intToMonth(item.month)}/${item.year}`,
            year: item.year,
            month: item.month,
            score: item.monthScore,
            averageScore: item.averageScore,
            activeServices: item.activeServices,
            relationshipTime: item.relationshipTime,
          }
          return result;
        }));

      } catch (e: any) {
        console.error('Error fetching relationship:', e);
        setError(e.message);
      } finally {
        setIsLoading(false);
      }
    };
    if(assetId){
      getConnectionEngagementData();
    }
  }, [offset, assetId]);

  return {
    connectionEngagementResponseList,
    pagination,
    setPagination,
    isLoading,
    error,
  };
};